module.exports = __webpack_public_path__ + "img/专利证书01_IDC数据机房空调系统能源管理平台v1.0.b40d3247.png";